import { createContext, useContext } from 'react';

export const TemplateDetailsContext = createContext(null);

export function useTemplateDetailsContext() {
  const ctx = useContext(TemplateDetailsContext);
  if (!ctx) {
    throw new Error('useTemplateDetailsContext must be used within TemplateDetailsPage');
  }
  return ctx;
}
